/**
 * Predictive Search Quick Links Enhancement
 * 
 * This script enhances the predictive search to show quick links (featured products)
 * when the search input is empty.
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const predictiveSearch = document.querySelector('predictive-search');
    if (!predictiveSearch) return;

    const resultsContainer = predictiveSearch.querySelector('[slot="results"]');
    if (!resultsContainer) return;

    // Store the initial quick links HTML
    const quickLinksHTML = resultsContainer.innerHTML;

    // Find the search form and input
    const searchForm = document.querySelector('[aria-owns="header-predictive-search"]');
    if (!searchForm) return;

    const searchInput = searchForm.querySelector('input[type="search"]');
    if (!searchInput) return;

    // Create a MutationObserver to watch for changes to the results container
    const observer = new MutationObserver(function(mutations) {
      // Check if the input is empty and results were cleared
      if (searchInput.value === '' && resultsContainer.innerHTML === '') {
        // Restore the quick links
        resultsContainer.innerHTML = quickLinksHTML;
      }
    });

    // Start observing the results container
    observer.observe(resultsContainer, {
      childList: true,
      subtree: false
    });

    // Also listen to input changes directly
    searchInput.addEventListener('input', function() {
      // Small delay to ensure the predictive search has processed
      setTimeout(function() {
        if (searchInput.value === '' && resultsContainer.innerHTML === '') {
          resultsContainer.innerHTML = quickLinksHTML;
        }
      }, 50);
    });

    // Listen to form reset
    searchForm.addEventListener('reset', function() {
      setTimeout(function() {
        resultsContainer.innerHTML = quickLinksHTML;
      }, 50);
    });
  }
})();
